export const CharSymbol = {
    Percent: String.fromCharCode(0x25),
    Degree: String.fromCharCode(0xB0),
    Celsius: `${String.fromCharCode(0xB0)} C`,
    Fahrenheit: `${String.fromCharCode(0xB0)} F`,
    Dash: String.fromCharCode(0x2d),
    EmDash: String.fromCharCode(0x2014),
    DoubleDash: String.fromCharCode(0x2d) + String.fromCharCode(0x2d)
} as const;
